import path from "path";
import { lazyImport } from "../helpers/lazyImport";
import { NotFound } from "../modules/misc";
import { TermsRoutes } from "../modules/terms-and-condition";

const { AuthRoutes }: any = lazyImport(
  () => import("../modules/auth"),
  "AuthRoutes"
);
const { TestRoutes }: any = lazyImport(
  () => import("../modules/test"),
  "TestRoutes"
);
const { DashboardRoutes }: any = lazyImport(
  () => import("../modules/dashboard"),
  "DashboardRoutes"
);

const { AnnotationRoutes }: any = lazyImport(
  () => import("../modules/annotation"),
  "AnnotationRoutes"
);

const { OnBoardingRoutes }: any = lazyImport(
  () => import("../modules/on-boarding"),
  "OnBoardingRoutes"
);

export const publicRoutes = [
  {
    path: "/auth/*",
    element: <AuthRoutes />,
  },
  {
    path: "/test/*",
    element: <TestRoutes />,
  },
  {
    path: "/app/dashboard/*",
    element: <DashboardRoutes />,
  },
  {
    path: "/app/annotation/*",
    element: <AnnotationRoutes />,
  },
  {
    path: "/app/terms-and-conditions/*",
    element: <TermsRoutes />,
  },
  {
    path: "/app/on-boarding/*",
    element: <OnBoardingRoutes />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
